import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('options/list', { params });
  },
  async add(params: any) {
    return axios.post('options/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('options/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('options/detail', { params });
  },
  async delete(params: any) {
    return axios.post('options/delete', qs.stringify(params));
  },
  async items(params: any) {
    return axios.get('optionitems/list', { params });
  },
  async additem(params: any) {
    return axios.post('optionitems/add', qs.stringify(params));
  },
  async edititem(params: any) {
    return axios.post('optionitems/edit', qs.stringify(params));
  },
  async getitem(params: any) {
    return axios.get('optionitems/detail', { params });
  },
  async deleteitem(params: any) {
    return axios.post('optionitems/delete', qs.stringify(params));
  }
};
